/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GatedNFT, GatedNFTInterface } from "../GatedNFT";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "string",
            name: "description",
            type: "string",
          },
          {
            internalType: "string",
            name: "animationUrl",
            type: "string",
          },
          {
            internalType: "string",
            name: "imageUrl",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "animationHash",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "imageHash",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct GatedNFT.Config",
        name: "config",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "contract ITier",
        name: "tier",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minimumStatus",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxPerAddress",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum GatedNFT.Transferrable",
        name: "transferrable",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxMintable",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "royaltyRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "royaltyBPS",
        type: "uint256",
      },
    ],
    name: "CreatedGatedNFT",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "royaltyRecipient",
        type: "address",
      },
    ],
    name: "UpdatedRoyaltyRecipient",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "string",
            name: "description",
            type: "string",
          },
          {
            internalType: "string",
            name: "animationUrl",
            type: "string",
          },
          {
            internalType: "string",
            name: "imageUrl",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "animationHash",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "imageHash",
            type: "bytes32",
          },
        ],
        internalType: "struct GatedNFT.Config",
        name: "config_",
        type: "tuple",
      },
      {
        internalType: "contract ITier",
        name: "tier_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minimumStatus_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxPerAddress_",
        type: "uint256",
      },
      {
        internalType: "enum GatedNFT.Transferrable",
        name: "transferrable_",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "maxMintable_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "royaltyRecipient_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyBPS_",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice_",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tier",
    outputs: [
      {
        internalType: "contract ITier",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyRecipient_",
        type: "address",
      },
    ],
    name: "updateRoyaltyRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type GatedNFTConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GatedNFTConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GatedNFT__factory extends ContractFactory {
  constructor(...args: GatedNFTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GatedNFT> {
    return super.deploy(overrides || {}) as Promise<GatedNFT>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): GatedNFT {
    return super.attach(address) as GatedNFT;
  }
  connect(signer: Signer): GatedNFT__factory {
    return super.connect(signer) as GatedNFT__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GatedNFTInterface {
    return new utils.Interface(_abi) as GatedNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GatedNFT {
    return new Contract(address, _abi, signerOrProvider) as GatedNFT;
  }
}
